import { useWorkspace } from '~/features/workspaces/data.ts'
import Url from '~/utils/Url.ts'

import EmailNotVerifiedBanner from './components/EmailNotVerifiedBanner.tsx'
import ImpersonatorBanner from './components/ImpersonatorBanner.tsx'
import UnpaidInvoicesBanner from './components/UnpaidInvoicesBanner.tsx'
import WorkspaceCancelledBanner from './components/WorkspaceCancelledBanner.tsx'

interface Props {
  aboveHeader?: boolean
}

function Banners(props: Props) {
  const { aboveHeader } = props

  const { data } = useWorkspace()

  const loginData = data?.login_data
  if (aboveHeader) {
    if (loginData?.isImpersonated) {
      return <ImpersonatorBanner email={loginData.email} />
    }

    return null
  }

  return (
    <div className="messages">
      {/* Keep in mind in /old-crm order of banners is 1. cancelled, 2. email, 2. unpaid */}
      {data?.workspace?.cancelled && Url.isWorkspaceSpecificUrl(window.location.pathname) && (
        <WorkspaceCancelledBanner workspace={data.workspace} />
      )}

      {data?.ifShowEmailVerificationBanner && (
        <EmailNotVerifiedBanner email={data?.login_data.email} />
      )}

      {data?.ifShowUnpaidInvoicesBanner && Url.isWorkspaceSpecificUrl(window.location.pathname) && (
        <UnpaidInvoicesBanner />
      )}
    </div>
  )
}

export default Banners
